import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/calendar.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-00971c3c")

_pushScopeId("data-v-00971c3c")
const _hoisted_1 = { class: "w-full flex flex-row gap-4 justify-end" }
const _hoisted_2 = {
  key: 0,
  class: "w-200px max-w-none cursor-pointer flex flex-row"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-40px flex justify-center items-center border-l border-t border-b border-gray-lp-400 rounded-l-full bg-gray-lp-1000" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "calendar"
  })
], -1)
const _hoisted_4 = { class: "relative w-full rounded-full" }
const _hoisted_5 = { class: "border border-gray-lp-400 col-span-2 p-1 bg-white rounded-full flex flex-row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomSelect = _resolveComponent("CustomSelect")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isCustom)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_CustomSelect, {
              options: _ctx.monthsOptions,
              onSelect: _cache[1] || (_cache[1] = (e) => _ctx.onSelectMonth({ ...e, code: 'select' })),
              selectedItem: _ctx.selectedMonth,
              placeholder: _ctx.$t('dashboard.leaderboard.filterMonth.placeholder'),
              class: "w-full h-full",
              customClassField: "rounded-r-full",
              customStyleField: "position: relative; z-index: 99;",
              customClassExpand: "absolute flex border-none pt-5 transform -translate-y-5 rounded-b-lg"
            }, null, 8, ["options", "selectedItem", "placeholder"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", {
        class: 
          `px-4 py-2 grid place-items-center cursor-pointer relative rounded-full ${
            _ctx.isCustom ? 'bg-red-lp-2000' : ''
          }`
        ,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setIsCustom && _ctx.setIsCustom(...args)))
      }, [
        _createVNode("span", {
          class: `text-14px ${_ctx.isCustom ? 'font-bold text-white' : ''}`
        }, _toDisplayString(_ctx.$t('dashboard.leaderboard.filterMonth.selectMonth')), 3)
      ], 2),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.monthsData.monthTabs, (item) => {
        return (_openBlock(), _createBlock("div", {
          key: item.name,
          class: 
          `px-4 py-2 grid place-items-center cursor-pointer relative rounded-full ${
            _ctx.selectedMonth.name === item.name && !_ctx.isCustom
              ? 'bg-red-lp-2000'
              : ''
          }`
        ,
          onClick: ($event: any) => (_ctx.onSelectMonth({ ...item, code: 'tab' }))
        }, [
          _createVNode("span", {
            class: 
            `text-14px ${
              _ctx.selectedMonth.name === item.name && !_ctx.isCustom
                ? 'font-bold text-white'
                : ''
            }`
          
          }, _toDisplayString(item.key === _ctx.filterMonthLeaderboardKeys.CURRENT_MONTH
              ? _ctx.$t('dashboard.leaderboard.filterMonth.currentMonth')
              : item.name), 3)
        ], 10, ["onClick"]))
      }), 128))
    ])
  ]))
})